// extracted by mini-css-extract-plugin
module.exports = {"disabled":"d09cd5504551caed06d33c44712bc672-less"};